import type { FormMode, FormValidation, IdentityFormData } from "@/screen/Identities/Interfaces/IdentityFormInterfaces";

export function getInitialFormData(mode: FormMode): IdentityFormData
{
    return {
        firstName: "",
        lastName: "",
        secondLastName: "",
        email: "",
        countryPrefix: "",
        phone: "",
        operationCountryPrefix: "",
        operationPhone: "",
        signatureCountryPrefix: "",
        signaturePhone: "",
        useSinglePhone: false,
        birthday: null,
        birthdayCountry: "ES",
        nationalCountry: "ES",
        idType: "DNI",
        idDocument: "",
        idExpiration: null,
        hasPermanentIdExpiration: false,
        idFront: null,
        idBack: null,
        postalAddress: null,
        fiscalAddress: null,
        sameAddress: true,
        role: "Owner",
        main: false,
        isMinor: mode === "createMinor",
        economicActivity: null,
        proofOfIncome: null,
        gafiQuestion: undefined,
        publicPosition: undefined,
        maxContribution: null,
        proofOfMinorGuardian: null,
        proofOfMinorGuardianDescription: "",
        maritalStatus: null,
        profession: null,
        residenceCountry: null,
        fatcaStatus: null,
        residenceOfficialDocument: null,
        noResidenceDocument: null,
        hasTaxIdInUS: undefined,
        hasResidenceInUS: undefined,
        hasTaxObligationInUS: undefined,
        annualGrossIncome: null,
        hasEmployedActivity: undefined,
        hasSelfEmployedActivity: undefined,
        employedActivities: [],
        selfEmployedActivities: [],
        fundsOrigin: null,
        fundsDocumentationProvided: null,
        internationalCommercialActivity: undefined,
        isPepRelative: undefined,
        numberOfDependants: null,
        otherNationalities: undefined,
        otherNationality: "",
        otherPersonalCircumstances: null,
        riskCountries: undefined,
        riskJurisdictionActivity: undefined,
        maritalSituation: null,
        isUsCitizen: undefined
    };
}

export function getInitialValidation(): FormValidation
{
    return {
        firstName: false,
        lastName: false,
        secondLastName: false,
        email: false,
        phone: false,
        operationPhone: false,
        signaturePhone: false,
        countryPrefix: false,
        operationCountryPrefix: false,
        signatureCountryPrefix: false,
        birthday: false,
        // El alta arranca con España seleccionada en ambos países (ver getInitialFormData)
        birthdayCountry: true,
        nationalCountry: true,
        idDocument: false,
        idExpiration: false,
        idFront: false,
        idBack: false,
        postalAddress: false,
        // Vacío permitido si sameAddress es true
        fiscalAddress: true,
        economicActivity: false,
        proofOfIncome: false,
        gafiQuestion: false,
        publicPosition: false,
        proofOfMinorGuardian: true,
        maritalStatus: false,
        profession: false,
        residenceCountry: false,
        fatcaStatus: false,
        residenceOfficialDocument: false,
        noResidenceDocument: false,
        hasTaxIdInUS: false,
        hasResidenceInUS: false,
        hasTaxObligationInUS: false,
        annualGrossIncome: false,
        hasEmployedActivity: false,
        hasSelfEmployedActivity: false,
        employedActivities: false,
        selfEmployedActivities: false,
        fundsOrigin: false,
        fundsDocumentationProvided: false,
        internationalCommercialActivity: false,
        isPepRelative: false,
        numberOfDependants: false,
        otherNationalities: false,
        // Condicionales: válidos mientras su condición no aplique
        otherNationality: true,
        otherPersonalCircumstances: false,
        riskCountries: false,
        riskJurisdictionActivity: false,
        maritalSituation: true,
        isUsCitizen: false
    };
}
